import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: "Accueil", path: "/" },
    { name: "À propos", path: "/about" },
    { name: "Services", path: "/services" },
    { name: "Galerie", path: "/gallery" },
    { name: "Contact", path: "/contact" },
  ];

  const isActive = (path: string) => {
    if (path === "/" && location.pathname !== "/") return false;
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="bg-white shadow-lg fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-2xl font-bold text-salon-primary">
              Kam's Beauty
            </Link>
          </div>

          {/* Desktop menu */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`transition-colors ${
                  isActive(item.path)
                    ? "text-salon-primary font-semibold"
                    : "text-gray-600 hover:text-salon-primary"
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/appointment"
              className={`px-4 py-2 rounded-md shadow-md hover:shadow-lg transition-all ${
                isActive("/appointment")
                  ? "bg-salon-primary text-white"
                  : "bg-white text-salon-primary border-2 border-salon-primary hover:bg-salon-primary hover:text-white"
              }`}
            >
              Prendre RDV
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-gray-600 hover:text-salon-primary"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  className={`block px-3 py-2 rounded-md ${
                    isActive(item.path)
                      ? "bg-salon-primary/10 text-salon-primary font-semibold"
                      : "text-gray-600 hover:text-salon-primary hover:bg-salon-primary/5"
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/appointment"
                className={`block px-3 py-2 rounded-md ${
                  isActive("/appointment")
                    ? "bg-salon-primary text-white"
                    : "bg-white text-salon-primary border border-salon-primary hover:bg-salon-primary hover:text-white"
                }`}
                onClick={() => setIsOpen(false)}
              >
                Prendre RDV
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;